const translations = {
  "en": {
    "Are you behind on retirement savings": "Are you behind on retirement savings",
    "Check-up": "Check-up",
    "Feature": "Feature",
    "Finance Reality Check": "Finance Reality Check",
    "Financial Fitness": "Financial Fitness",
    "Financial Fitness Check": "Financial Fitness Check",
    "Guides": "Guides",
    "Money Personality": "Money Personality",
    "Pricing": "Pricing",
    "RSU vested money tool": "RSU vested money tool",
    "What is a Money Person": "What is a Money Person",
    "What is Financial Fitness": "What is Financial Fitness",
    "Will You Be a Billionaire": "Will You Be a Billionaire"
  },
  "zh-tw": {
    "Are you behind on retirement savings": "怎麼衡量退休儲蓄是否足夠",
    "Check-up": "健檢",
    "Feature": "功能",
    "Finance Reality Check": "財務現實檢查",
    "Financial Fitness": "財務健康",
    "Financial Fitness Check": "財務健康檢查",
    "Guides": "指南",
    "Money Personality": "理財性格測試",
    "Pricing": "定價",
    "RSU vested money tool": "RSU 歸屬後怎樣理財",
    "What is a Money Person": "什麼是私人理財官",
    "What is Financial Fitness": "Financial Fitness 是什麼",
    "Will You Be a Billionaire": "你會成為億萬富翁嗎？"
  }
};

export default translations;
